import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.9953 9.98282C18.9953 10.5452 18.5265 10.9857 17.9952 10.9857H16.9951L17.017 15.991C17.0232 17.1002 16.1263 18 15.0168 18H5.00347C3.90025 18 3.0033 17.1033 3.0033 16.0004V10.9857H2.00009C1.43754 10.9857 1 10.5483 1 9.98282C1 9.70162 1.09376 9.45167 1.31253 9.23296L9.32571 2.24995C9.54448 2.03124 9.7945 2 10.0133 2C10.232 2 10.4821 2.06249 10.6696 2.21871L18.6515 9.23296C18.9015 9.45167 19.0265 9.70162 18.9953 9.98282Z",
		fill: "#0D2976"
	})
});
export default SvgHome;
